export const SET_SUGGEST_ASSOCIATE_JOB =
  'app/suggestAssociate/SET_SUGGEST_ASSOCIATE_JOB';

export const SET_ADVANCED_SEARCH = 'app/suggestAssociate/SET_ADVANCED_SEARCH';
